import React from 'react';
import styles from './EventContentHeader.module.scss';

function EventContentHeader(props) {
    const {className = '', children, style} = props;

    return (
        <h1 className={[styles.Title, className].join(' ')} style={style}>
            {children}
        </h1>
    );
}

export default EventContentHeader;
